import React, { useEffect, useState } from 'react'
import { sanity, urlFor } from '../lib/sanityClient'
import { Separator } from '@/components/ui/separator'
import { ArrowDown } from 'lucide-react'

function About() {
  const [data, setData] = useState(null)

  useEffect(() => {
    sanity
      .fetch(`*[_type == "aboutPage"][0]{ title, body, caption, heroImage }`)
      .then(setData)
      .catch(console.error)
  }, [])

  const paragraphs =
    data?.body?.split(/\n\s*\n/).filter(Boolean) ?? []

    const imageUrl =
    data?.heroImage &&
    urlFor(data.heroImage).width(1200).quality(80).url()  

  const altText =
    data?.heroImage?.alt || 'About image'

  return (
    <>
    <div className='grid grid-cols-1 xl:grid-cols-2 gap-6 w-full px-2 pt-2'>
    <div className='flex relative  w-full'>

    {imageUrl && (
    <img
      src={imageUrl}
      alt={data?.heroImage?.alt || ''}
      className="w-full h-[45vh] xl:h-[calc(100vh-10.2rem)] object-cover aspect-[4/4] rounded-3xl"
      loading="eager"
    />
  )}

{!imageUrl && (
  <div className="w-full rounded-3xl bg-neutral-200 animate-pulse" />
)}


<figure className="absolute inset-0 flex items-end justify-end text-white bg-black bg-opacity-20 rounded-3xl">
  <figcaption className="text-lg mb-0 font-sans font-medium text-center max-w-prose mx-auto p-4">
    {data?.caption ?? 'Silk Surveys, 2024'}
  </figcaption>
</figure>
      </div>
    <div
      className='font-sans text-left max-w-prose w-full mx-auto my-auto px-4'>
      <h1 className="text-lg font-medium  mb-6 font-sans">{data?.title ?? 'About'}</h1>
      <div className="text-3xl font-kalice my-6">
            {!data ? (
              <p>Loading…</p>
            ) : (
              paragraphs.map((p, i) => (
                <p key={i} className="mb-6">
                  {p}
                </p>
              ))
            )}
          </div>
          {/* <ArrowDown className='w-4 h-4 mt-12'/> */}
</div>
</div>

{/* <Separator className='border border-white/20 my-2'></Separator> */}

    </>
  );
}

export default About;
